import { useReactiveVar } from '@apollo/client'

import { Chart } from 'shared/__gql-types'
import { useLoading, useServerError } from 'shared/hooks'
import { countryCodeVar, labelCodeIdVar, spaceIdVar } from 'modulesCommon/store'

import { useGetTopChartingProductsQuery } from '../graphql/getTopChartingProducts.types'
import { TOP_CHARTING_PRODUCTS_LIMIT } from '../constants'

export const useTopChartingProducts = () => {
  const label_id = useReactiveVar(labelCodeIdVar)
  const countryCode = useReactiveVar(countryCodeVar)
  const space_id = useReactiveVar(spaceIdVar)

  const {
    data: productsResponse,
    loading: productsLoading,
    error: productsError
  } = useGetTopChartingProductsQuery({
    variables: {
      label_id,
      space_id,
      countryCode,
      limit: TOP_CHARTING_PRODUCTS_LIMIT
    },
    skip: (!label_id && !space_id) || !countryCode
  })

  useLoading({ isLoading: productsLoading })
  useServerError([productsError])

  const products: Chart[] = productsResponse?.getTopChartingProducts ?? []

  return {
    products,
    productsLoading
  }
}
